var _defs, _g;

var _excluded = ["svgRef", "title"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var SvgActivation = function SvgActivation(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 90,
    height: 77,
    viewBox: "0 0 90 77",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient",
    x1: 0.444,
    y1: 2.08,
    x2: 0.444,
    y2: 0.698,
    gradientUnits: "objectBoundingBox"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "gray",
    stopOpacity: 0.251
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.54,
    stopColor: "gray",
    stopOpacity: 0.122
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "gray",
    stopOpacity: 0.102
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-2",
    x1: 0.027,
    y1: 4.202,
    x2: 0.027,
    y2: 3.205,
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-3",
    x1: 0.684,
    y1: 0.372,
    x2: 0.684,
    y2: -0.628,
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-4",
    x1: 1.326,
    y1: -2.088,
    x2: 1.326,
    y2: -3.089,
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-5",
    x1: 0.5,
    y1: 1,
    x2: 0.5,
    y2: 0,
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-6",
    x1: -8.568,
    y1: 1,
    x2: -8.568,
    y2: 0,
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-7",
    x1: 0.5,
    y1: 1,
    x2: 0.5,
    y2: 0,
    xlinkHref: "#linear-gradient"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "activation",
    transform: "translate(-0.328 -0.023)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_5540",
    "data-name": "Group 5540",
    transform: "translate(41.592 0.023)",
    opacity: 0.5
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_6299",
    "data-name": "Rectangle 6299",
    width: 56.352,
    height: 40.785,
    transform: "translate(0 55.722) rotate(-81.42)",
    fill: "url(#linear-gradient)"
  })), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_6300",
    "data-name": "Rectangle 6300",
    width: 55.107,
    height: 39.747,
    transform: "translate(42.23 55.001) rotate(-81.42)",
    fill: "#f5f5f5"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_6301",
    "data-name": "Rectangle 6301",
    width: 28.687,
    height: 1.739,
    transform: "translate(52.119 24.932) rotate(8.58)",
    fill: "#e0e0e0"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_6302",
    "data-name": "Rectangle 6302",
    width: 28.687,
    height: 1.739,
    transform: "translate(51.471 29.229) rotate(8.58)",
    fill: "#e0e0e0"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_6303",
    "data-name": "Rectangle 6303",
    width: 14.779,
    height: 1.739,
    transform: "translate(67.947 13.253) rotate(8.58)",
    fill: "#e0e0e0"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_6304",
    "data-name": "Rectangle 6304",
    width: 12.171,
    height: 1.739,
    transform: "translate(68.589 17.746) rotate(8.58)",
    fill: "#00bfa6"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_6305",
    "data-name": "Rectangle 6305",
    width: 25.211,
    height: 1.739,
    transform: "translate(50.822 33.527) rotate(8.58)",
    fill: "#e0e0e0"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_6306",
    "data-name": "Rectangle 6306",
    width: 21.733,
    height: 1.739,
    transform: "translate(50.173 37.825) rotate(8.58)",
    fill: "#e0e0e0"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_6307",
    "data-name": "Rectangle 6307",
    width: 19.125,
    height: 1.739,
    transform: "translate(49.525 42.123) rotate(8.58)",
    fill: "#e0e0e0"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_6308",
    "data-name": "Rectangle 6308",
    width: 24.341,
    height: 1.739,
    transform: "translate(48.876 46.421) rotate(8.58)",
    fill: "#e0e0e0"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_6309",
    "data-name": "Rectangle 6309",
    width: 9.562,
    height: 1.739,
    transform: "translate(48.229 50.719) rotate(8.58)",
    fill: "#00bfa6"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_5541",
    "data-name": "Group 5541",
    transform: "translate(53.637 8.95)",
    opacity: 0.5
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_226",
    "data-name": "Path 226",
    d: "M692.448,169.432a5.8,5.8,0,1,0-9.657,3.414v.026a1.987,1.987,0,0,0,.588.515l.011-.025a5.432,5.432,0,0,0,2.61,1h.029a5.31,5.31,0,0,0,2.588-.193s.009-.014.025-.041a2.068,2.068,0,0,0,.6-.289l.018-.064A5.8,5.8,0,0,0,692.448,169.432Z",
    transform: "translate(-680.907 -162.764)",
    fill: "url(#linear-gradient-2)"
  })), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_243",
    "data-name": "Ellipse 243",
    cx: 5.628,
    cy: 5.628,
    r: 5.628,
    transform: "translate(53.009 19.266) rotate(-81.42)",
    fill: "#f5f5f5"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_227",
    "data-name": "Path 227",
    d: "M700.286,235.076s-1.338-.092-1.356,2.377a1.925,1.925,0,0,0,.57.5l1.126-2.412Z",
    transform: "translate(-643.437 -218.681)",
    fill: "#fda57d"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_228",
    "data-name": "Path 228",
    d: "M749.872,241.39s1.31.309.6,2.672a1.926,1.926,0,0,1-.692.309l-.365-2.637Z",
    transform: "translate(-688.721 -224.345)",
    fill: "#fda57d"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_229",
    "data-name": "Path 229",
    d: "M707.776,196.72s-.908,1.741-1.226,1.516c0,0,2.889,3.37,6.254.943a8.848,8.848,0,0,0-1.011-1.853Z",
    transform: "translate(-650.273 -184.274)",
    fill: "#333"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_244",
    "data-name": "Ellipse 244",
    cx: 2.495,
    cy: 2.495,
    r: 2.495,
    transform: "translate(56.825 14.691) rotate(-81.42)",
    fill: "#333"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_230",
    "data-name": "Path 230",
    d: "M708.661,235.7l-4.3-.649-.661,1.661s-.356.761-.115,1.156a5.84,5.84,0,0,0,5.045.824,2.271,2.271,0,0,0,.274-1.426c-.108-.838-.048-.066-.048-.066Z",
    transform: "translate(-647.535 -218.658)",
    opacity: 0.1
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_231",
    "data-name": "Path 231",
    d: "M709.23,235.789l-4.3-.649-.66,1.66s-.356.761-.115,1.156a5.84,5.84,0,0,0,5.045.824,2.27,2.27,0,0,0,.274-1.426c-.108-.838-.048-.066-.048-.066Z",
    transform: "translate(-648.046 -218.739)",
    opacity: 0.1
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_232",
    "data-name": "Path 232",
    d: "M708.911,235.739l-4.3-.649-.661,1.661s-.356.761-.115,1.156a5.84,5.84,0,0,0,5.045.824,2.271,2.271,0,0,0,.274-1.426c-.108-.838-.048-.066-.048-.066Z",
    transform: "translate(-647.759 -218.694)",
    fill: "#fdd835"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_233",
    "data-name": "Path 233",
    d: "M0,0H1.742V1.571a.693.693,0,0,1-.693.693H.693A.693.693,0,0,1,0,1.571V0Z",
    transform: "translate(58.382 15.171) rotate(8.58)",
    opacity: 0.1
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_234",
    "data-name": "Path 234",
    d: "M0,0H1.741V1.571a.693.693,0,0,1-.693.693H.693A.693.693,0,0,1,0,1.571Z",
    transform: "translate(58.391 15.108) rotate(8.58)",
    fill: "#fda57d"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_235",
    "data-name": "Path 235",
    d: "M726.77,223.146a2.505,2.505,0,0,0,1.72.265l.032-.211-1.721-.259Z",
    transform: "translate(-668.411 -207.795)",
    opacity: 0.1
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_245",
    "data-name": "Ellipse 245",
    cx: 2.495,
    cy: 2.495,
    r: 2.495,
    transform: "translate(56.744 15.226) rotate(-81.42)",
    fill: "#fda57d"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_236",
    "data-name": "Path 236",
    d: "M717.07,178.537l4.7.709a2.217,2.217,0,0,0-1.912-2.107A3.217,3.217,0,0,0,717.07,178.537Z",
    transform: "translate(-659.71 -166.7)",
    fill: "#333"
  }), /*#__PURE__*/React.createElement("ellipse", {
    id: "Ellipse_246",
    "data-name": "Ellipse 246",
    cx: 0.435,
    cy: 0.232,
    rx: 0.435,
    ry: 0.232,
    transform: "translate(56.888 13.057) rotate(-81.42)",
    fill: "#fda57d"
  }), /*#__PURE__*/React.createElement("ellipse", {
    id: "Ellipse_247",
    "data-name": "Ellipse 247",
    cx: 0.435,
    cy: 0.232,
    rx: 0.435,
    ry: 0.232,
    transform: "translate(61.708 13.785) rotate(-81.42)",
    fill: "#fda57d"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_237",
    "data-name": "Path 237",
    d: "M717,179.157l4.7.709a2.217,2.217,0,0,0-1.912-2.107A3.217,3.217,0,0,0,717,179.157Z",
    transform: "translate(-659.647 -167.256)",
    opacity: 0.1
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_5542",
    "data-name": "Group 5542",
    transform: "translate(0.328 8.029)",
    opacity: 0.5
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_6310",
    "data-name": "Rectangle 6310",
    width: 40.901,
    height: 56.513,
    transform: "matrix(0.987, -0.16, 0.16, 0.987, 0, 6.526)",
    fill: "url(#linear-gradient-3)"
  })), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_6311",
    "data-name": "Rectangle 6311",
    width: 39.747,
    height: 55.107,
    transform: "translate(0.875 14.785) rotate(-9.31)",
    fill: "#f5f5f5"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_6312",
    "data-name": "Rectangle 6312",
    width: 28.687,
    height: 1.739,
    transform: "translate(9.971 37.507) rotate(-9.31)",
    fill: "#e0e0e0"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_6313",
    "data-name": "Rectangle 6313",
    width: 28.687,
    height: 1.739,
    transform: "translate(10.674 41.797) rotate(-9.31)",
    fill: "#e0e0e0"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_6314",
    "data-name": "Rectangle 6314",
    width: 14.779,
    height: 1.739,
    transform: "translate(21.447 21.531) rotate(-9.31)",
    fill: "#e0e0e0"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_6315",
    "data-name": "Rectangle 6315",
    width: 12.171,
    height: 1.739,
    transform: "translate(23.437 25.61) rotate(-9.31)",
    fill: "#00bfa6"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_6316",
    "data-name": "Rectangle 6316",
    width: 25.211,
    height: 1.739,
    transform: "translate(11.377 46.086) rotate(-9.31)",
    fill: "#e0e0e0"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_6317",
    "data-name": "Rectangle 6317",
    width: 21.733,
    height: 1.739,
    transform: "translate(12.08 50.375) rotate(-9.31)",
    fill: "#e0e0e0"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_6318",
    "data-name": "Rectangle 6318",
    width: 19.125,
    height: 1.739,
    transform: "translate(12.783 54.665) rotate(-9.31)",
    fill: "#e0e0e0"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_6319",
    "data-name": "Rectangle 6319",
    width: 24.341,
    height: 1.739,
    transform: "translate(13.487 58.953) rotate(-9.31)",
    fill: "#e0e0e0"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_6320",
    "data-name": "Rectangle 6320",
    width: 9.562,
    height: 1.739,
    transform: "translate(14.191 63.243) rotate(-9.31)",
    fill: "#00bfa6"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_5543",
    "data-name": "Group 5543",
    transform: "translate(8.213 19.262)",
    opacity: 0.5
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_238",
    "data-name": "Path 238",
    d: "M251.54,267.93a5.965,5.965,0,1,0-8.37,6.389l.008.026a2.041,2.041,0,0,0,.737.315v-.028a5.576,5.576,0,0,0,2.87.158h.029a5.454,5.454,0,0,0,2.471-1.006.168.168,0,0,1,.01-.047,2.124,2.124,0,0,0,.493-.472V273.2A5.959,5.959,0,0,0,251.54,267.93Z",
    transform: "translate(-239.688 -262.931)",
    fill: "url(#linear-gradient-4)"
  })), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_248",
    "data-name": "Ellipse 248",
    cx: 5.786,
    cy: 5.786,
    r: 5.786,
    transform: "translate(7.535 20.451) rotate(-9.31)",
    fill: "#f5f5f5"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_239",
    "data-name": "Path 239",
    d: "M270.123,346.48s-1.338.335-.577,2.754a1.981,1.981,0,0,0,.716.309l.341-2.716Z",
    transform: "translate(-258.049 -318.616)",
    fill: "#4d8af0"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_240",
    "data-name": "Path 240",
    d: "M317.065,339.444s1.379-.112,1.425,2.427a1.981,1.981,0,0,1-.58.515l-1.19-2.465Z",
    transform: "translate(-300.576 -312.304)",
    fill: "#4d8af0"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_249",
    "data-name": "Ellipse 249",
    cx: 2.565,
    cy: 2.565,
    r: 2.565,
    transform: "translate(10.679 21.141) rotate(-9.31)",
    fill: "#333"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_241",
    "data-name": "Path 241",
    d: "M280.166,339.49l-4.415.721-.122,1.833s-.1.858.252,1.167a5.985,5.985,0,0,0,5.19-.791,2.333,2.333,0,0,0-.182-1.481c-.371-.786-.069-.049-.069-.049Z",
    transform: "translate(-263.703 -312.346)",
    fill: "#4d8af0"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_242",
    "data-name": "Path 242",
    d: "M280.736,339.4l-4.415.721-.122,1.834s-.1.858.252,1.167a5.986,5.986,0,0,0,5.19-.791,2.334,2.334,0,0,0-.182-1.482c-.371-.785-.069-.049-.069-.049Z",
    transform: "translate(-264.215 -312.265)",
    fill: "#4d8af0"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_243",
    "data-name": "Path 243",
    d: "M280.416,339.45l-4.415.721-.122,1.837s-.1.858.252,1.167a5.986,5.986,0,0,0,5.19-.791,2.334,2.334,0,0,0-.182-1.481c-.371-.786-.069-.049-.069-.049Z",
    transform: "translate(-263.928 -312.31)",
    fill: "#4d8af0"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_244",
    "data-name": "Path 244",
    d: "M0,0H1.79V1.634a.693.693,0,0,1-.693.693h-.4A.693.693,0,0,1,0,1.634V0Z",
    transform: "translate(13.189 26.176) rotate(-9.31)",
    opacity: 0.1
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_245",
    "data-name": "Path 245",
    d: "M0,0H1.79V1.634a.693.693,0,0,1-.693.693h-.4A.693.693,0,0,1,0,1.634V0Z",
    transform: "translate(13.178 26.11) rotate(-9.31)",
    fill: "#fda57d"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_246",
    "data-name": "Path 246",
    d: "M288.035,327.551a2.574,2.574,0,0,0,1.767-.284l-.036-.217-1.766.29Z",
    transform: "translate(-274.813 -301.187)",
    opacity: 0.1
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_250",
    "data-name": "Ellipse 250",
    cx: 2.565,
    cy: 2.565,
    r: 2.565,
    transform: "translate(10.769 21.69) rotate(-9.31)",
    fill: "#fda57d"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_247",
    "data-name": "Path 247",
    d: "M268.18,282.086l4.827-.791a2.275,2.275,0,0,0-2.536-1.458A3.321,3.321,0,0,0,268.18,282.086Z",
    transform: "translate(-257.034 -258.779)",
    opacity: 0.1
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_248",
    "data-name": "Path 248",
    d: "M268.07,281.447l4.832-.792a2.275,2.275,0,0,0-2.536-1.458A3.332,3.332,0,0,0,268.07,281.447Z",
    transform: "translate(-256.935 -258.205)",
    fill: "#333"
  }), /*#__PURE__*/React.createElement("ellipse", {
    id: "Ellipse_251",
    "data-name": "Ellipse 251",
    cx: 0.24,
    cy: 0.449,
    rx: 0.24,
    ry: 0.449,
    transform: "matrix(0.987, -0.16, 0.16, 0.987, 10.941, 23.849)",
    fill: "#fda57d"
  }), /*#__PURE__*/React.createElement("ellipse", {
    id: "Ellipse_252",
    "data-name": "Ellipse 252",
    cx: 0.239,
    cy: 0.448,
    rx: 0.239,
    ry: 0.448,
    transform: "translate(15.854 22.89) rotate(-9.31)",
    fill: "#fda57d"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_5544",
    "data-name": "Group 5544",
    transform: "translate(29.391 17.056)",
    opacity: 0.5
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_6321",
    "data-name": "Rectangle 6321",
    width: 40.785,
    height: 56.352,
    fill: "url(#linear-gradient-5)"
  })), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_6322",
    "data-name": "Rectangle 6322",
    width: 39.747,
    height: 55.107,
    transform: "translate(29.91 17.471)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_5545",
    "data-name": "Group 5545",
    transform: "translate(35.219 23.981)",
    opacity: 0.5
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_249",
    "data-name": "Path 249",
    d: "M502,314.86a6.1,6.1,0,1,1,9.5,5.062v.027a2.087,2.087,0,0,1-.692.441l-.008-.027a5.7,5.7,0,0,1-2.869.633h-.03a5.6,5.6,0,0,1-2.66-.606s-.007-.016-.018-.046a2.172,2.172,0,0,1-.576-.394l-.009-.069A6.093,6.093,0,0,1,502,314.86Z",
    transform: "translate(-502 -308.761)",
    fill: "url(#linear-gradient-6)"
  })), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_253",
    "data-name": "Ellipse 253",
    cx: 5.916,
    cy: 5.916,
    r: 5.916,
    transform: "translate(35.401 24.164)",
    fill: "#f5f5f5"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_250",
    "data-name": "Path 250",
    d: "M529.11,389.89s-1.409.114-1.037,2.688a2.027,2.027,0,0,0,.671.427l.793-2.684Z",
    transform: "translate(-490.114 -357.557)",
    fill: "#be7c5e"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_251",
    "data-name": "Path 251",
    d: "M579.424,389.89s1.409.114,1.037,2.688a2.025,2.025,0,0,1-.671.427l-.79-2.692Z",
    transform: "translate(-535.854 -357.557)",
    fill: "#be7c5e"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_252",
    "data-name": "Path 252",
    d: "M535.932,349s-.108.316-.262.682c-.336.8.047,3.869.85,4.2a4.56,4.56,0,0,0,3.316.153c1.07-.39,1.4-3.884.643-4.736-.089-.1-.181-.2-.278-.3Z",
    transform: "translate(-496.876 -320.877)",
    fill: "#333"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_254",
    "data-name": "Ellipse 254",
    cx: 2.622,
    cy: 2.622,
    r: 2.622,
    transform: "translate(38.698 25.319)",
    fill: "#333"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_253",
    "data-name": "Path 253",
    d: "M538.448,389.89h-4.574l-.427,1.829s-.251.847.061,1.22a6.117,6.117,0,0,0,5.367.061,2.386,2.386,0,0,0,.061-1.525c-.244-.854-.061-.061-.061-.061Z",
    transform: "translate(-494.905 -357.557)",
    opacity: 0.1
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_254",
    "data-name": "Path 254",
    d: "M539.02,389.89h-4.576l-.427,1.829s-.251.847.061,1.22a6.117,6.117,0,0,0,5.367.061,2.386,2.386,0,0,0,.061-1.525c-.244-.854-.061-.061-.061-.061Z",
    transform: "translate(-495.417 -357.557)",
    opacity: 0.1
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_255",
    "data-name": "Path 255",
    d: "M538.708,389.89h-4.574l-.427,1.829s-.251.847.061,1.22a6.118,6.118,0,0,0,5.367.061,2.385,2.385,0,0,0,.061-1.525c-.244-.854-.061-.061-.061-.061Z",
    transform: "translate(-495.138 -357.557)",
    fill: "#3ad29f"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_256",
    "data-name": "Path 256",
    d: "M389.541,299.11h1.829V300.8a.693.693,0,0,1-.693.693h-.445a.693.693,0,0,1-.693-.693V299.11Z",
    transform: "translate(-349.142 -268.296)",
    opacity: 0.1
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_257",
    "data-name": "Path 257",
    d: "M389.541,298.45h1.829v1.686a.693.693,0,0,1-.693.693h-.445a.693.693,0,0,1-.693-.693V298.45Z",
    transform: "translate(-349.142 -267.704)",
    fill: "#be7c5e"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_258",
    "data-name": "Path 258",
    d: "M552.35,375.044a2.633,2.633,0,0,0,1.829,0v-.224H552.35Z",
    transform: "translate(-511.948 -344.039)",
    opacity: 0.1
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_255",
    "data-name": "Ellipse 255",
    cx: 2.622,
    cy: 2.622,
    r: 2.622,
    transform: "translate(38.698 25.888)",
    fill: "#be7c5e"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_259",
    "data-name": "Path 259",
    d: "M536.91,326.568h5a2.326,2.326,0,0,0-2.317-1.89A3.4,3.4,0,0,0,536.91,326.568Z",
    transform: "translate(-498.098 -299.053)",
    fill: "#333"
  }), /*#__PURE__*/React.createElement("ellipse", {
    id: "Ellipse_256",
    "data-name": "Ellipse 256",
    cx: 0.244,
    cy: 0.457,
    rx: 0.244,
    ry: 0.457,
    transform: "translate(38.509 27.942)",
    fill: "#be7c5e"
  }), /*#__PURE__*/React.createElement("ellipse", {
    id: "Ellipse_257",
    "data-name": "Ellipse 257",
    cx: 0.244,
    cy: 0.457,
    rx: 0.244,
    ry: 0.457,
    transform: "translate(43.632 27.942)",
    fill: "#be7c5e"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_260",
    "data-name": "Path 260",
    d: "M536.91,327.218h5a2.326,2.326,0,0,0-2.317-1.89A3.4,3.4,0,0,0,536.91,327.218Z",
    transform: "translate(-498.098 -299.636)",
    opacity: 0.1
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_6323",
    "data-name": "Rectangle 6323",
    width: 28.687,
    height: 1.739,
    transform: "translate(35.21 41.366)",
    fill: "#e0e0e0"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_6324",
    "data-name": "Rectangle 6324",
    width: 28.687,
    height: 1.739,
    transform: "translate(35.21 45.712)",
    fill: "#e0e0e0"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_6325",
    "data-name": "Rectangle 6325",
    width: 14.779,
    height: 1.739,
    transform: "translate(49.12 27.457)",
    fill: "#e0e0e0"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_6326",
    "data-name": "Rectangle 6326",
    width: 12.171,
    height: 1.739,
    transform: "translate(50.423 31.804)",
    fill: "#00bfa6"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_6327",
    "data-name": "Rectangle 6327",
    width: 25.211,
    height: 1.739,
    transform: "translate(35.21 50.059)",
    fill: "#e0e0e0"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_6328",
    "data-name": "Rectangle 6328",
    width: 21.733,
    height: 1.739,
    transform: "translate(35.21 54.406)",
    fill: "#e0e0e0"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_6329",
    "data-name": "Rectangle 6329",
    width: 19.125,
    height: 1.739,
    transform: "translate(35.21 58.753)",
    fill: "#e0e0e0"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_6330",
    "data-name": "Rectangle 6330",
    width: 24.341,
    height: 1.739,
    transform: "translate(35.21 63.1)",
    fill: "#e0e0e0"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_6331",
    "data-name": "Rectangle 6331",
    width: 9.562,
    height: 1.739,
    transform: "translate(35.21 67.446)",
    fill: "#00bfa6"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_5546",
    "data-name": "Group 5546",
    transform: "translate(58.738 59.647)",
    opacity: 0.5
  }, /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_258",
    "data-name": "Ellipse 258",
    cx: 8.688,
    cy: 8.688,
    r: 8.688,
    fill: "url(#linear-gradient-7)"
  })), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_259",
    "data-name": "Ellipse 259",
    cx: 8.176,
    cy: 8.176,
    r: 8.176,
    transform: "translate(59.249 60.158)",
    fill: "#00bfa6"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_261",
    "data-name": "Path 261",
    d: "M606.468,621.8l3.066,2.811,4.344-6.387,1.534,1.278-5.877,7.665-4.343-4.854Z",
    transform: "translate(-542.591 -554.553)",
    fill: "#fff"
  }))));
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgActivation, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/activation.7223297e.svg";
export { ForwardRef as ReactComponent };